import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import ItemMode from './ItemMode'

const ModeMarking = () => {
  const mode = useSelector((state) => state?.classMarking?.mode || [])

  return (
    <div className='absolute bottom-0 z-12 flex flex-col gap-2' style={{ zIndex: 100 }}>
      {mode.length > 0 &&
        mode.map((item, index) => {
          return <ItemMode key={`log-${item.studentId}-${index}-${item._id}`} item={item} />
        })}
    </div>
  )
}

export default ModeMarking
